import { useContext, useMemo } from 'react';
import { StoreContext } from './notifier.provider.js';

function useNotifier() {
  const store = useContext(StoreContext);
  return useMemo(
    () => ({
      notify: function(toast) {
        return notify(store, toast);
      },
      dialog: function(dialogConfig) {
        return dialog(store, dialogConfig);
      },
      confirm: function(confirmConfig) {
        return confirm(store, confirmConfig);
      },
      modal: function(modalConfig) {
        return modal(store, modalConfig);
      }
    }),
    [store]
  );
}
function notify(store, toast) {
  const state = store.refs;
  const id = toast.id ?? getAutoIncrementedId();
  const onDismiss = () => {
    store.actions.removeToast(id);
  };
  const cancelAutoDismiss = () => {
  };
  if (state.toasts.current.find((it) => it.id === id)) {
    store.actions.replaceToast(id, {
      ...toast,
      id,
      onDismiss,
      cancelAutoDismiss
    });
    return;
  } else {
    store.actions.addToast({
      ...toast,
      id,
      onDismiss,
      cancelAutoDismiss
    });
  }
}
async function dialog(store, dialogConfig) {
  const id = getAutoIncrementedId();
  return new Promise((resolve) => {
    const onSelect = (intent) => {
      store.actions.removeDialog(id);
      resolve(intent);
    };
    store.actions.addDialog({
      ...dialogConfig,
      id,
      onSelect
    });
  });
}
async function confirm(store, dialogConfig) {
  var _a, _b;
  const { include = { ok: true, cancel: true } } = dialogConfig;
  const { ok = true, cancel = true } = include;
  return dialog(store, {
    ...dialogConfig,
    actions: [
      cancel && {
        label: ((_a = dialogConfig.labels) == null ? void 0 : _a.cancel) ?? "Annuller",
        type: "secondary",
        intent: "cancel"
      },
      ok && {
        label: ((_b = dialogConfig.labels) == null ? void 0 : _b.ok) ?? "OK",
        type: "primary",
        intent: "ok"
      }
    ].filter((it) => !!it)
  });
}
async function modal(store, modalConfig) {
  const id = getAutoIncrementedId();
  return new Promise((resolve) => {
    const onDismiss = (output) => {
      store.actions.removeModal(id);
      resolve(output);
    };
    store.actions.addModal({
      ...modalConfig,
      id,
      onDismiss
    });
  });
}
let autoIncrementedId = 0;
function getAutoIncrementedId() {
  return `${++autoIncrementedId}`;
}

export { useNotifier };
//# sourceMappingURL=notifier.manager.js.map
